{
  "title": {
    "selectKind": "Khiếu nại",
    "details": "Lý do khiếu nại",
    "amountMismatch": "Số tiền không khớp"
  },
  "submitButton": {
    "selectKind": "Tiếp theo",
    "details": "Xác nhận",
    "amountMismatch": "Yêu cầu chỉnh sửa số tiền"
  },
  "selectKind": {
    "title": "Loại khiếu nại",
    "options": {
      "UploadPaymentProofFailed": "Không thể tải ảnh lên",
      "BankInfoError": "Không thể chuyển khoản qua thẻ ngân hàng",
      "WechatInfoError": "Không thể quét mã QR WeChat",
      "AlipayInfoError": "Không thể quét mã QR Alipay",
      "QQInfoError": "Không thể quét mã QR QQ",
      "SellerDidNotConfirm": "Người bán không giải phóng token",
      "CannotConfirmBuyerPaymentProof": "Tài khoản nhận tiền có vấn đề, không thể xác nhận",
      "AmountMismatch": "Số tiền không khớp",
      "SellerNotReceivedPayment": "Chưa nhận được tiền",
      "Other": "Khác"
    }
  },
  "details": {
    "title": "Lý do khiếu nại",
    "placeholder": "Nhập lý do khiếu nại",
    "uploadImage": "Tải ảnh lên",
    "uploadImageTip": "Tải từ 1 đến 3 ảnh, mỗi ảnh không quá 5MB; hỗ trợ JPG, JPEG, PNG.",
    "submitFailed": "Gửi thất bại",
    "maxCharacters": "Số ký tự vượt quá giới hạn 800.",
    "modal": {
      "title": "Xác nhận khiếu nại",
      "content": "Sau khi khiếu nại, bộ phận hỗ trợ sẽ tham gia xử lý giao dịch này cho đến khi kết thúc.",
      "cancel": "Hủy",
      "confirm": "Xác nhận khiếu nại"
    }
  },
  "amountMismatch": {
    "description": "Nếu số tiền nhận được không khớp với dự kiến, hãy nhập số tiền thực tế bạn nhận được bên dưới. Khi người mua đồng ý, lệnh sẽ được đổi thành số tiền bạn đã nhập và số lượng giao dịch {{token}} tương ứng cũng được cập nhật.",
    "estimatedAmount": "Dự kiến nhận được",
    "actualAmount": "Thực nhận",
    "placeholder": "Nhập số tiền yêu cầu chỉnh sửa",
    "uploadImage": "Tải bằng chứng giao dịch lên",
    "uploadImageTip": "Tải từ 1 đến 3 ảnh, mỗi ảnh không quá 5MB; hỗ trợ JPG, JPEG, PNG.",
    "amountExceedsRemaining": "Số tiền tăng thêm vượt quá số lượng còn lại của lệnh gốc, vui lòng nhập lại",
    "changeInProgress": "Một lệnh khác thuộc cùng lệnh bán đang chỉnh sửa số tiền. Tạm thời chưa thể chỉnh sửa số tiền của lệnh này, vui lòng thử lại sau.",
    "exceedsOriginal": "Nếu số lượng cần chỉnh sửa vượt quá số lượng giao dịch gốc, hãy khiếu nại",
    "limitTitle": "Giới hạn chỉnh sửa số tiền"
  },
  "back": "Quay lại",
  "SellerNotReceivedPayment": {
    "description": "Hãy quay và tải lên video sao kê ngân hàng, trong đó phải hiển thị rõ thời gian hiện tại.\nBạn có thể làm theo các bước: mở cửa hàng ứng dụng > tìm và mở ứng dụng ngân hàng > thông tin thẻ > chi tiết giao dịch."
  }
}
